module.exports = __webpack_public_path__ + "static/media/third-image.27f0adae.png";